@import "../../../global/temporary-mercury-overrides/_button.scss";

:host {
  display: grid;
  grid-template-rows: 1fr max-content;
  overflow: auto;
}

.section {
  display: contents;
}

.main {
  grid-auto-rows: max-content;
}

.source-container {
  display: grid;
  grid-template-columns: 1fr max-content;
  gap: var(--spacing-gap-m);
}

.footer {
  margin-block-start: 16px;
}
